import axios from 'axios';//ספריה שמאפשרת לבצע קריאות שרת
// יצירה של משתנה שמכיל את ההגדרות הבסיסיות של הקריאת שרת שנבצע בשימוש במשתנה הזה
//שזה חוזר על עצמו במלא מקומות - url הגדרות בסיסיות  - לדוגמא כתובת 

const api = axios.create({//אוביקט שמכיל הגדרה בסיסית של כתובת URL משותף לכל הקונטרולרים
    baseURL: '/api/',
    headers: {
        "Content-Type": "application/json"//הנתונים מועברים מהשרת ולשרת כאוביקט ג'יסון
    }
})
// כדי לבצע קריאות שרת ללא ההתחלה של הכתובת utils ייצוא של המשתנה ושימוש בקבצים של 
export default api;
 